var cilClone = ["512 512", "<path fill='var(--ci-primary-color, currentColor)' d='M472,16H160a24.027,24.027,0,0,0-24,24V352a24.027,24.027,0,0,0,24,24H472a24.027,24.027,0,0,0,24-24V40A24.027,24.027,0,0,0,472,16Zm-8,328H168V48H464Z' class='ci-primary'/><path fill='var(--ci-primary-color, currentColor)' d='M344,464H48V168h56V136H40a24.027,24.027,0,0,0-24,24V472a24.027,24.027,0,0,0,24,24H352a24.027,24.027,0,0,0,24-24V408H344Z' class='ci-primary'/>"];

export { cilClone };

